export const ANIMATION_DURATION = 350;
